// Spanish overrides for SERVICES, CATEGORIES, DOCTORS, TESTIMONIALS.
// Keyed by slug / id. Falls back to English when a key is missing.

export const CATEGORIES_ES = {
  cosmetic: {
    title: "Odontología Estética",
    blurb:
      "Realza la belleza natural de tu sonrisa con tratamientos diseñados para transformarla — discretamente.",
  },
  restorative: {
    title: "Odontología Restaurativa",
    blurb:
      "Recupera fuerza, función y confianza para dientes desgastados, rotos o ausentes.",
  },
  implants: {
    title: "Implantes Dentales",
    blurb:
      "El estándar de oro para reemplazar dientes ausentes — diseñados para durar toda la vida.",
  },
  general: {
    title: "Odontología General y Familiar",
    blurb:
      "Atención preventiva y conservadora para cada miembro de tu familia, a cualquier edad.",
  },
  surgery: {
    title: "Cirugía Oral",
    blurb:
      "Cirugía avanzada realizada en el consultorio por doctores con formación en Harvard.",
  },
  periodontics: {
    title: "Periodoncia",
    blurb:
      "Cuidado de encías y tejidos de soporte — la base de toda sonrisa sana.",
  },
  sedation: {
    title: "Odontología con Sedación",
    blurb:
      "Odontología enfocada en la comodidad para pacientes ansiosos y tratamientos complejos.",
  },
};

export const TESTIMONIALS_ES = {
  "Rashid F.":
    "Disfruté del servicio del Dr. Yopa y su personal. Se tomaron el tiempo de hablar conmigo sobre mi problema dental y de educarme en cada paso. Soy paciente de Smiles of Loudoun de por vida.",
  "Leeann L.":
    "Personal cálido y amigable. Muy profesionales y directos. Me dijeron exactamente qué necesitaba y cuándo me sentiría cómoda para iniciar el proceso. ¡La mejor oficina dental del área! La recomiendo a todos.",
  "Soheila Y.":
    "¡Gracias Smiles of Loudoun por una experiencia maravillosa! Mi hijo disfrutó cada minuto del tratamiento. El doctor fue paciente y minucioso. Sin duda traeré a toda mi familia.",
  "Avasa J.":
    "¡Qué gran experiencia! Todos son extremadamente profesionales y la calidad del cuidado es excepcional. ¡Personal y doctor increíbles! Los recomiendo ampliamente.",
};

export const DOCTORS_ES = {
  "Dr. Steve Yopa": {
    title: "Dentista General",
    bio: [
      "El Dr. Steve Yopa es un dentista general con formación en endodoncia, cirugía oral y mucho más. Cuando se mudó de Camerún a los Estados Unidos, asistió a George Mason University en Fairfax, Virginia, y se graduó con una Licenciatura en Ciencias en bioquímica y un minor en salud global y comunitaria.",
      "Después continuó en la Meharry Medical College School of Dentistry en Nashville, Tennessee, donde recibió su Doctorado en Cirugía Dental. Durante sus estudios completó múltiples pasantías en distintas instituciones, incluyendo la Harvard School of Dental Medicine y la Boston University Henry M. Goldman School of Dental Medicine, con énfasis en cirugía oral y maxilofacial y medicina oral. También se enorgullece de haber sido el único en su clase en recibir el premio al estudiante líder destacado del American College of Dentists. Tras graduarse de la escuela de odontología, se mudó a Nueva York para completar su formación de posgrado (residencia en práctica general) en el Bronx-Lebanon Hospital Center. También completó un programa de desarrollo de liderazgo en salud oral para poder educar y tratar a sus pacientes con un enfoque integral.",
      "El Dr. Yopa también recibió una beca de dos años en implantología oral del programa de posgrado de NYU. Hoy es reconocido como fellow del International Congress of Oral Implantologists (ICOI).",
      "El Dr. Yopa ayuda a sus pacientes a lograr sonrisas hermosas y aporta sus excepcionales habilidades estéticas a todo lo que hace: resinas estéticas (sin metal), carillas, coronas, injertos óseos y restauración de implantes. El Dr. Yopa habla inglés y francés.",
    ],
  },
  "Dr. Serena Ide Noumy": {
    title: "Dentista General",
    bio: [
      "Nacida y criada en Camerún, la Dra. Serena Ide Noumy comenzó un viaje transformador en 2005 cuando se mudó a los Estados Unidos. Se estableció en Richmond, Virginia, donde cursó sus estudios en Virginia Commonwealth University, obteniendo tanto su licenciatura como su doctorado en odontología. Esta formación integral sentó una base sólida, dándole las habilidades y el conocimiento para atender a sus pacientes con compasión, respeto y excelencia clínica.",
      "Tras completar sus estudios, la Dra. Noumy realizó una residencia de un año en Arizona, donde perfeccionó sus habilidades prácticas en un entorno clínico ágil. Después se trasladó a Dallas, Texas, donde ejerció la odontología durante cinco años. En ese tiempo desarrolló una mayor apreciación por la complejidad del cuidado del paciente y la importancia de construir relaciones significativas y duraderas dentro de la comunidad.",
      "A pesar de su gratificante experiencia en Texas, la Dra. Noumy sintió una fuerte atracción por regresar a Virginia, el estado que consideraba su hogar. Motivada por el deseo de retribuir a la comunidad que apoyó sus inicios profesionales, regresó con un renovado compromiso de brindar atención excepcional. Trata a cada paciente como si fuera de su familia y se enfoca en educar a las personas sobre la importancia de la salud bucal. Como miembro activa de múltiples asociaciones dentales, se mantiene al día con los últimos avances en odontología y se dedica a su desarrollo profesional continuo.",
      "Más allá de la odontología, la Dra. Noumy valora el equilibrio y la conexión en su vida personal. Disfruta del voluntariado, viajar, entrenar y bailar salsa. Estas pasiones no solo enriquecen su propia vida, sino que también le permiten contribuir de manera significativa a las comunidades a las que sirve.",
      "Hoy, la Dra. Noumy se honra de servir a su comunidad con dignidad y compasión, esforzándose por dejar un impacto duradero y positivo en la vida de sus pacientes.",
    ],
  },
  "Dr. Salar Ebrahimi": {
    title: "Anestesiólogo Dental",
    bio: [
      "El Dr. Salar Ebrahimi creció en el sur de California con una pasión por el arte y la medicina. A lo largo de su vida, el Dr. Ebrahimi supo que quería ayudar a las personas a través de su profesión y encontró su pasión por el arte en el campo de la odontología. Obtuvo su Licenciatura en Ciencias en biología, su maestría en ciencias biomédicas y su Doctorado en Cirugía Dental en Howard University College of Dentistry en Washington, DC.",
      "El Dr. Ebrahimi fue admitido en la prestigiosa National Dental Honor Society tras destacarse en la escuela de odontología. También es miembro de la American Dental Association® y de la American Society of Dental Anesthesia. En su tiempo libre, el Dr. Ebrahimi disfruta de viajar, pasar tiempo con su familia y crear arte.",
    ],
  },
};

export const SERVICES_ES = {
  invisalign: {
    title: "Invisalign®",
    tag: "Endereza tu sonrisa, discretamente.",
    short:
      "Alineadores transparentes y removibles hechos a la medida de tu mordida — para adultos y adolescentes.",
    long: [
      "Invisalign® es un enfoque moderno y transparente para enderezar dientes sin los alambres ni brackets visibles de los frenos tradicionales. En Smiles of Loudoun, nuestros dentistas ofrecen Invisalign a pacientes que buscan una forma discreta y conveniente de alinear sus dientes y mejorar su sonrisa.",
      "Invisalign usa una serie de alineadores plásticos transparentes hechos a la medida, que se ajustan cómodamente a tus dientes. Cada alineador aplica presión suave para mover los dientes hacia la posición deseada. Los pacientes cambian de alineador cada una o dos semanas, avanzando constantemente hacia su sonrisa ideal.",
    ],
    bullets: [
      "Prácticamente invisibles — sin brackets visibles",
      "Removibles y flexibles — come y cepíllate normalmente",
      "Mayor comodidad — plástico suave, amable con mejillas y encías",
      "Menos visitas a la oficina que con frenos tradicionales",
      "Efectivos para apiñamiento, espacios, sobremordida y mordida invertida",
    ],
    faq: [
      {
        q: "¿Cómo funciona el tratamiento Invisalign?",
        a: "Una serie de alineadores plásticos transparentes hechos a la medida mueven gradualmente los dientes a su lugar. Cada alineador se usa una o dos semanas antes de cambiarlo.",
      },
      {
        q: "¿Cuánto dura el tratamiento Invisalign?",
        a: "En promedio, la mayoría de los pacientes logra sus resultados deseados en 12 a 18 meses, aunque algunos ven mejoras antes.",
      },
      {
        q: "¿Son cómodos los alineadores Invisalign?",
        a: "Sí. Plástico suave hecho a la medida — sin alambres ni brackets, mucho menos irritación que con frenos.",
      },
      {
        q: "¿Puedo comer normalmente con Invisalign?",
        a: "Los alineadores son removibles, así que puedes comer tus comidas favoritas sin restricciones — solo retíralos al comer y beber cualquier cosa que no sea agua.",
      },
      {
        q: "¿Con qué frecuencia debo usar los alineadores?",
        a: "Para mejores resultados, úsalos de 20 a 22 horas al día — solo retíralos para comer, beber, cepillarte y usar hilo dental.",
      },
    ],
  },
  "cosmetic-gum-contouring": {
    title: "Tratamiento Estético de Encías",
    tag: "Adiós a la sonrisa gingival.",
    short:
      "Remodelado suave para revelar más del diente que ya amas.",
    long: [
      "El contorneado estético de encías (también llamado lifting gingival) remodela suavemente la línea de las encías para revelar más de tu diente natural y crear una sonrisa equilibrada y uniforme.",
      "Realizado con láseres de precisión para tejidos blandos, el tratamiento es rápido, cómodo y produce resultados inmediatos — con mínima recuperación.",
    ],
    bullets: [
      "Corrige la \"sonrisa gingival\" para mejor proporción",
      "Empareja una línea de encías asimétrica",
      "Tratamiento láser cómodo con mínima recuperación",
      "Suele combinarse con carillas o blanqueamiento",
    ],
    faq: [
      { q: "¿Duele el contorneado de encías?", a: "No — el tratamiento láser es muy suave y adormecemos el área para mayor comodidad." },
      { q: "¿Cuánto duran los resultados?", a: "En la mayoría de los casos son permanentes, especialmente con buena higiene oral." },
    ],
  },
  "teeth-whitening": {
    title: "Blanqueamiento Dental",
    tag: "Una sonrisa nacarada completa.",
    short:
      "Blanqueamiento profesional — en la oficina o con bandejas para llevar a casa.",
    long: [
      "Años de café, té, vino y tiempo pueden opacar incluso los dientes más sanos. Nuestro blanqueamiento profesional levanta las manchas profundas con seguridad — mucho más allá de lo que las tiras de farmacia logran.",
      "Elige un tratamiento en la oficina para resultados dramáticos el mismo día, o bandejas a la medida para blanquear a tu ritmo.",
    ],
    bullets: [
      "Blanqueamiento seguro supervisado por dentista",
      "Bandejas a la medida para resultado uniforme",
      "Opción en la oficina para resultado el mismo día",
      "Resultados hermosos y duraderos con mantenimiento",
    ],
    faq: [
      { q: "¿Es seguro para mi esmalte?", a: "Sí — el blanqueamiento profesional es seguro al usarse según indicación, con mucho menor riesgo de sensibilidad que las opciones de farmacia." },
      { q: "¿Cuánto duran los resultados?", a: "Típicamente 1–2 años con retoques en casa." },
    ],
  },
  "porcelain-veneers": {
    title: "Carillas de Porcelana",
    tag: "Una sonrisa nueva, natural y deslumbrante.",
    short:
      "Carillas finas hechas a mano que realzan tu belleza natural.",
    long: [
      "Las carillas de porcelana son láminas delgadas hechas para adherirse al frente de tus dientes — corrigiendo instantáneamente forma, color, longitud y problemas menores de alineación en pocas visitas.",
      "Cada carilla se modela según tu rostro, sonrisa y personalidad para un resultado completamente natural — no \"hecho\".",
    ],
    bullets: [
      "Corrige fracturas, espacios, manchas y pequeñas alineaciones",
      "Porcelana realista y resistente a manchas",
      "Mínimamente invasivo con preparación conservadora",
      "Resultados duraderos y hermosos",
    ],
    faq: [
      { q: "¿Cuánto duran las carillas?", a: "Con buen cuidado, las carillas de porcelana suelen durar 10 a 15 años o más." },
      { q: "¿Las carillas dañan mis dientes?", a: "No — se remodela una capa muy delgada de esmalte para crear una unión fuerte y conservadora." },
    ],
  },
  "dental-crowns": {
    title: "Coronas Dentales",
    tag: "Restaura forma, tamaño y fuerza.",
    short:
      "Coronas a la medida que protegen el diente y se ven completamente naturales.",
    long: [
      "Cuando un diente está fracturado, muy desgastado o ha tenido endodoncia, una corona dental restaura su fuerza mientras luce y se siente como el diente que recuerdas.",
      "Hacemos coronas con porcelana o zirconia durables y realistas, igualadas al color de tu sonrisa natural.",
    ],
    bullets: [
      "Protege dientes fracturados, debilitados o tratados",
      "Opciones realistas en porcelana y zirconia",
      "Color personalizado para integrarse con dientes vecinos",
      "Restaura una masticación cómoda",
    ],
    faq: [
      { q: "¿Cuánto duran las coronas?", a: "Típicamente 10 a 20 años con buena higiene oral." },
    ],
  },
  "iv-sedation": {
    title: "Sedación Intravenosa",
    tag: "Odontología sin dolor, de verdad.",
    short:
      "Sedación enfocada en la comodidad, administrada por doctores capacitados en consultorio.",
    long: [
      "Para pacientes con ansiedad dental o necesidades complejas, la sedación IV ofrece relajación profunda durante la visita — la mayoría no recuerda nada de la cita.",
      "Toda la sedación es administrada y monitoreada por el Dr. Yopa, formado específicamente en cirugía oral, maxilofacial y sedación.",
    ],
    bullets: [
      "Ideal para ansiedad dental o procedimientos largos",
      "Administrada por el doctor y monitoreada continuamente",
      "Despiertas descansado, no traumatizado",
      "Completa varios tratamientos en una sola visita",
    ],
    faq: [
      { q: "¿Estaré inconsciente?", a: "La sedación IV produce relajación profunda — permaneces receptivo pero la mayoría no recuerda el procedimiento." },
      { q: "¿Cuándo puedo conducir?", a: "Un familiar o amigo debe llevarte a casa; la recuperación total suele ocurrir en 24 horas." },
    ],
  },
  "dental-implants": {
    title: "Implantes Dentales",
    tag: "Come los alimentos duros, con confianza.",
    short:
      "Raíces de titanio quirúrgico con coronas que se sienten como las tuyas.",
    long: [
      "Los implantes dentales son el estándar de oro para reemplazar dientes ausentes — un poste de titanio se ancla en el hueso mandibular y sostiene una corona personalizada que luce, se siente y funciona como un diente natural.",
      "Los implantes preservan el hueso, estabilizan los dientes vecinos y duran décadas con el cuidado adecuado.",
    ],
    bullets: [
      "Luce, se siente y funciona como un diente natural",
      "Preserva el hueso mandibular y la estructura facial",
      "No depende de los dientes vecinos para sostén",
      "Diseñado para durar toda la vida con buen cuidado",
    ],
    faq: [
      { q: "¿Soy candidato?", a: "La mayoría de los adultos con buena salud general y densidad ósea adecuada son buenos candidatos — el Dr. Yopa está formado en implantología en NYU." },
      { q: "¿Cuánto dura el proceso?", a: "Desde la colocación hasta la corona final suele tomar de 3 a 6 meses, mientras el implante se integra al hueso." },
    ],
  },
  "dental-bridges": {
    title: "Puentes Dentales",
    tag: "Cierra el espacio, mantén la sonrisa.",
    short:
      "Restauraciones fijas que cubren dientes ausentes en un plan de visitas.",
    long: [
      "Un puente dental reemplaza uno o más dientes ausentes anclando un diente (o dientes) artificial natural a los dientes vecinos o a implantes.",
      "Restaura tu sonrisa, tu mordida y evita que los dientes restantes se muevan de su lugar.",
    ],
    bullets: [
      "Cubre el espacio de uno o más dientes ausentes",
      "Restaura masticación y habla cómodas",
      "Se ve hermosamente natural",
      "Previene el desplazamiento de dientes adyacentes",
    ],
    faq: [
      { q: "¿Cuánto dura un puente?", a: "Típicamente 10 a 15 años con buena higiene oral y limpiezas regulares." },
    ],
  },

  /* ----- Sub-services ----- */
  "dental-bonding": {
    title: "Adhesión Dental",
    tag: "Soluciones rápidas para fracturas y espacios.",
    short:
      "Resina del color del diente esculpida en una sola visita para reparar fracturas, espacios y pequeños defectos.",
    long: [
      "La adhesión dental usa resina compuesta del color del diente que esculpimos y endurecemos directamente sobre tu diente — restaurando fracturas, cerrando espacios pequeños y remodelando imperfecciones.",
      "La mayoría de las adhesiones se completan en una sola visita, sin impresiones ni espera de laboratorio.",
    ],
    bullets: [
      "Repara dientes fracturados, agrietados o desgastados",
      "Cierra pequeños espacios para una sonrisa más pareja",
      "Tratamiento de una visita, usualmente sin anestesia",
      "Alternativa accesible y conservadora a las carillas",
    ],
    faq: [
      { q: "¿Cuánto dura la adhesión?", a: "Típicamente dura de 5 a 10 años, dependiendo de la ubicación y tus hábitos." },
      { q: "¿Se mancha?", a: "La resina compuesta puede manchar con el tiempo — café, vino tinto y tabaco son los culpables habituales." },
    ],
  },
  "composite-fillings": {
    title: "Resinas Estéticas",
    tag: "Reparaciones invisibles de caries.",
    short:
      "Resinas sin mercurio, del color del diente, adheridas directamente a tu diente.",
    long: [
      "Las resinas estéticas (del color del diente) restauran dientes con caries o daño usando un material que se integra perfectamente con tu esmalte natural.",
      "A diferencia de las amalgamas de plata, las resinas se adhieren directamente al diente — fortaleciendo la estructura y requiriendo menos desgaste.",
    ],
    bullets: [
      "Prácticamente invisibles — igualadas al tono de tu diente",
      "Sin mercurio ni metales",
      "Adheridas al diente para mayor fuerza",
      "Conservadoras — preservan más diente natural",
    ],
    faq: [
      { q: "¿Cuánto duran?", a: "Las resinas suelen durar de 7 a 10 años dependiendo del tamaño y la fuerza de la mordida." },
    ],
  },
  dentures: {
    title: "Dentaduras",
    tag: "Sonrisa segura, mordida completa.",
    short:
      "Dentaduras parciales y totales hechas a medida para un ajuste cómodo y natural.",
    long: [
      "Las dentaduras modernas son más ligeras, cómodas y mucho más realistas que las de hace una década.",
      "Hacemos dentaduras totales y parciales, y podemos estabilizarlas con mini-implantes para un ajuste sin deslizamiento al hablar y masticar.",
    ],
    bullets: [
      "Dientes a la medida con apariencia natural",
      "Opciones totales y parciales",
      "Estabilización opcional con implantes",
      "Restaura masticación, habla y volumen facial",
    ],
    faq: [
      { q: "¿Cuánto dura el proceso?", a: "Desde las primeras impresiones hasta el ajuste final suele tomar de 3 a 6 semanas." },
      { q: "¿Pueden ser sobre implantes?", a: "Sí — algunos implantes pueden estabilizar dramáticamente una dentadura superior o inferior." },
    ],
  },
  "root-canal-therapy": {
    title: "Endodoncia",
    tag: "Salva tu diente, sin dolor.",
    short:
      "Endodoncia moderna y cómoda que alivia el dolor y rescata un diente dañado.",
    long: [
      "La endodoncia trata la infección o inflamación profunda dentro del diente — alivia el dolor y te permite conservar tu diente natural en vez de extraerlo.",
      "Con tecnología moderna y anestesia, el procedimiento suele ser tan cómodo como una resina.",
    ],
    bullets: [
      "Alivia el dolor profundo por infección",
      "Preserva tu diente natural",
      "Tratamiento de una o dos visitas en la mayoría de los casos",
      "Se realiza con anestesia cómoda",
    ],
    faq: [
      { q: "¿Duele la endodoncia?", a: "La mayoría de los pacientes dice que se siente como una resina normal." },
      { q: "¿Necesitaré una corona después?", a: "Los molares posteriores casi siempre — la corona protege el diente tratado de fracturarse al masticar." },
    ],
  },
  "dental-cleanings-exams": {
    title: "Limpiezas y Exámenes",
    tag: "Dos veces al año, toda la vida.",
    short:
      "Limpiezas y exámenes completos para prevenir problemas antes de que comiencen.",
    long: [
      "Las limpiezas y exámenes regulares son la mejor inversión en tu salud bucal a largo plazo. Cada seis meses, nuestros higienistas remueven placa y sarro, y nuestros dentistas revisan caries, enfermedad de encías y cáncer oral.",
      "Los pacientes nuevos pueden aprovechar nuestra Oferta de $129 — examen completo, rayos X digitales y limpieza minuciosa.",
    ],
    bullets: [
      "Remoción de placa y sarro",
      "Rayos X digitales según necesidad",
      "Detección de cáncer oral",
      "Pulido suave y tratamiento con flúor",
    ],
    faq: [
      { q: "¿Cada cuánto debo venir?", a: "La mayoría debe asistir cada 6 meses. Pacientes con enfermedad periodontal pueden necesitar visitas más frecuentes." },
    ],
  },
  "emergency-dentistry": {
    title: "Odontología de Emergencia",
    tag: "Atención el mismo día cuando duele.",
    short:
      "Dolor, hinchazón, un diente caído — llámanos y te atendemos rápido.",
    long: [
      "Las emergencias dentales no esperan. Ya sea un dolor severo, un diente caído, una corona rota o una hinchazón repentina, llama a nuestra oficina y haremos todo lo posible por verte el mismo día.",
      "Si no podemos atenderte de inmediato, te guiaremos por teléfono.",
    ],
    bullets: [
      "Citas el mismo día para atención urgente",
      "Alivio del dolor, control de infección y rescate del diente",
      "Guía telefónica paso a paso para emergencias fuera de horario",
    ],
    faq: [
      { q: "¿Qué cuenta como emergencia?", a: "Dolor severo, diente caído, sangrado que no se detiene, hinchazón facial, corona o relleno roto — llámanos de inmediato." },
      { q: "¿Qué hago con un diente caído?", a: "Sosténlo por la corona (no por la raíz), enjuágalo con suavidad y colócalo en leche o saliva. Llámanos enseguida — cada minuto cuenta." },
    ],
  },
  "night-guards": {
    title: "Protectores Nocturnos",
    tag: "Detén el bruxismo antes de que cueste.",
    short:
      "Protectores a la medida que cuidan tus dientes y mandíbula del bruxismo nocturno.",
    long: [
      "Si despiertas con mandíbula adolorida o dolor de cabeza — o tu pareja te oye rechinar los dientes — un protector nocturno a la medida puede proteger tus dientes de fracturarse y tu mandíbula de tensión crónica.",
      "Tomamos un escaneo digital y fabricamos un protector acrílico personalizado que se siente mucho menos voluminoso que los de farmacia.",
    ],
    bullets: [
      "Previene fracturas por bruxismo nocturno",
      "Reduce dolor mandibular y de cabeza por tensión",
      "Acrílico a la medida, delgado y cómodo",
      "Dura 5+ años con cuidado adecuado",
    ],
    faq: [
      { q: "¿Cómo se diferencia de los de farmacia?", a: "Los personalizados son más delgados, cómodos y se ajustan exactamente a tu mordida — mejor protección y uso constante." },
    ],
  },
  "tmj-treatment": {
    title: "Tratamiento de TMJ",
    tag: "Alivio del dolor mandibular y de cabeza.",
    short:
      "Cuidado conservador y por etapas para el TMJ — desde férulas hasta BOTOX® para tensión muscular.",
    long: [
      "Los trastornos TMJ (articulación temporomandibular) causan dolor mandibular, chasquidos, dolores de cabeza y hasta dolor de cuello. Usamos un enfoque conservador y por etapas — empezando por una férula a la medida y añadiendo terapias como BOTOX® o fisioterapia según sea necesario.",
      "La mayoría de los pacientes ve alivio significativo a las pocas semanas.",
    ],
    bullets: [
      "Férula/ortosis a la medida para reposicionar la mandíbula",
      "Inyecciones de BOTOX® para tensión muscular crónica",
      "Ajustes de mordida cuando es apropiado",
      "Referencias a fisioterapia cuando se indica",
    ],
    faq: [
      { q: "¿Necesito cirugía?", a: "Casi nunca. La gran mayoría de los trastornos TMJ se resuelven con cuidado conservador." },
    ],
  },
  "dental-sealants": {
    title: "Selladores Dentales",
    tag: "Prevención de caries para niños.",
    short:
      "Una capa protectora delgada que protege los molares de tu hijo contra caries.",
    long: [
      "Los selladores dentales son una capa plástica delgada que se aplica sobre la superficie masticatoria de los molares posteriores — sellando partículas de comida y bacterias que causan caries.",
      "Son rápidos, indoloros y una de las maneras más costo-efectivas de prevenir caries en niños en edad escolar.",
    ],
    bullets: [
      "Reduce hasta 80% el riesgo de caries en la superficie masticatoria",
      "Aplicación rápida e indolora en una sola visita",
      "Dura varios años con desgaste normal",
      "Suele estar cubierto por seguros dentales para niños",
    ],
    faq: [
      { q: "¿A qué edad colocarlos?", a: "Apenas salgan los molares permanentes — alrededor de los 6 años los primeros y los 12 años los segundos." },
    ],
  },
  "wisdom-teeth-removal": {
    title: "Extracción de Muelas del Juicio",
    tag: "Cirugía en consultorio.",
    short:
      "Extracción cómoda de muelas del juicio impactadas o problemáticas — sedación disponible.",
    long: [
      "Las muelas del juicio frecuentemente salen de lado o solo parcialmente — causando dolor, infección y apiñamiento. El Dr. Yopa está formado en cirugía oral y maxilofacial en Harvard y extrae muelas del juicio con comodidad en nuestra oficina.",
      "La mayoría de los pacientes elige sedación IV y no recuerda nada del procedimiento.",
    ],
    bullets: [
      "Extracción en consultorio por un cirujano experimentado",
      "Sedación IV disponible para experiencia sin estrés",
      "Reduce riesgo de infección, apiñamiento y quistes",
      "La mayoría se recupera en 3–5 días",
    ],
    faq: [
      { q: "¿Tengo que sacarme las cuatro?", a: "No siempre. Solo recomendamos sacar las que están impactadas, infectadas o amenazan dientes vecinos." },
    ],
  },
  "bone-grafting": {
    title: "Injerto Óseo",
    tag: "Restaura tu base.",
    short:
      "Reconstruye densidad ósea para sostener implantes o restaurar la estructura facial.",
    long: [
      "Cuando los dientes han estado ausentes mucho tiempo, el hueso mandibular se encoge. El injerto óseo devuelve volumen a ese hueso — creando una base firme para implantes o restaurando el contorno facial.",
      "Los materiales modernos se integran muy bien y el procedimiento suele completarse con anestesia local en una sola visita.",
    ],
    bullets: [
      "Crea base estable para implantes dentales",
      "Preserva hueso tras una extracción",
      "Restaura contorno facial y soporte de labios/mejillas",
      "Se realiza en consultorio con anestesia local o sedación IV",
    ],
    faq: [
      { q: "¿Cuánto tarda en sanar el injerto?", a: "La mayoría se integra en 3 a 6 meses, después se puede colocar el implante." },
    ],
  },
  "oral-conscious-sedation": {
    title: "Sedación Oral Consciente",
    tag: "Una pastilla, una visita relajada.",
    short:
      "Toma un sedante suave antes de tu cita para reducir la ansiedad.",
    long: [
      "La sedación oral consciente usa una pastilla recetada que se toma antes de la cita para aliviar la ansiedad y mantenerte profundamente relajado durante la visita.",
      "Te mantendrás despierto y receptivo, pero la mayoría se siente somnolienta y recuerda muy poco. Ideal para ansiedad dental leve a moderada.",
    ],
    bullets: [
      "Toma una sola pastilla antes de tu visita",
      "Relajación profunda sin sedación IV",
      "Ideal para ansiedad dental leve a moderada",
      "Requiere alguien que te lleve a casa",
    ],
    faq: [
      { q: "¿Estaré dormido?", a: "No — te sentirás profundamente relajado pero despierto y receptivo. La mayoría recuerda muy poco de la visita." },
    ],
  },
};

/**
 * Returns a service with Spanish overrides applied when lang === 'es'.
 */
export function localizeService(service, lang) {
  if (lang !== "es") return service;
  const es = SERVICES_ES[service.slug];
  if (!es) return service;
  return { ...service, ...es };
}

export function localizeCategory(cat, lang) {
  if (lang !== "es") return cat;
  const es = CATEGORIES_ES[cat.slug];
  return es ? { ...cat, ...es } : cat;
}

export function localizeDoctor(doc, lang) {
  if (lang !== "es") return doc;
  const es = DOCTORS_ES[doc.name];
  return es ? { ...doc, ...es } : doc;
}

export function localizeTestimonial(t, lang) {
  if (lang !== "es") return t;
  const es = TESTIMONIALS_ES[t.author];
  return es ? { ...t, quote: es } : t;
}
